import React, { useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import Home from "./home/home";
import ReCaptcha from "react-google-recaptcha";

function App() {
  const [isVerified, setIsVerified] = useState(false);

  const handleRecaptchaChange = (val) => {
    if (val) setIsVerified(true);
    else setIsVerified(false);
  };

  return (
    <div className="App">
      {/* {!isVerified ? (
        <div className="flex justify-center items-center h-screen">
          <ReCaptcha
            sitekey="6LdSbuopAAAAAACeC6ifF3S_GAcBqHO8d2LCedTo"
            onChange={handleRecaptchaChange}
            onError={(err) => console.log("We got error")}
          />  
        </div>
      ) : ( */}
        <Home />
      {/* )} */}
    </div>
  );
}

export default App;
